<div class="bg-pattern w-full h-full flex flex-col items-center justify-center">
    <div [@fadeInUp] class="card overflow-hidden w-full max-w-xs">
      <div class="p-6 pb-0 flex flex-col items-center justify-center">
        <div class="fill-current text-center">
          <img class="w-16" src="assets/img/demo/logo.png">
        </div>
      </div>
  
      <div class="text-center mt-4">
        <h2 class="title m-0">Reset Password</h2>
        <h4 class="body-2 text-secondary m-0">Enter your new password.</h4>
      </div>
      <div *ngIf="success" class="alert alert-success">
        <p>{{message}}</p>
      </div>
      <div *ngIf="error | async" class="alert alert-danger">
        <p>{{error | async}}</p>
      </div>
      <form (ngSubmit)="send()" [formGroup]="form" class="p-6 flex flex-col">
        <mat-form-field>
          <mat-label>Password</mat-label>
  
          <mat-icon class="mr-2" matPrefix svgIcon="mat:lock"></mat-icon>
          <input formControlName="password" matInput type="password" required>
          <mat-error *ngIf="form.get('password').hasError('required')">
            Password field is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Confirm Password</mat-label>
    
            <mat-icon class="mr-2" matPrefix svgIcon="mat:lock"></mat-icon>
            <input formControlName="confirmPassword" type="password" matInput required>
            <mat-error *ngIf="form.get('confirmPassword').errors">
              Password doesn't match.
            </mat-error>
          </mat-form-field>
  
        <button class="mt-2" color="primary" mat-raised-button type="submit">
          SEND RECOVERY LINK
        </button>
      </form>
    </div>
  </div>
  